import { useEffect, useMemo, useState } from "react";
import Style from "./ListUserApartmentStyle";
import { FaTrashAlt } from "react-icons/fa";
import Spinner from "../../shared/Spinner/Spinner";

export default function ListUserApartment({ users, userApartments, onAddUserApartment, onDeleteUserApartment }) {
  const [userId, setUserId] = useState<string | null>(null);


  const usersAvailable = useMemo(() => {
    return users.filter(
      user => !userApartments.some(ap => ap.userId === user.userId)
    );
  }, [users, userApartments]);

  useEffect(() => {
    if (usersAvailable.length > 0) {
      setUserId(usersAvailable[0].userId);
    } else {
      setUserId(null);
    }
  }, [usersAvailable]);

  if (userId == null)
    return (<Spinner spinning={userId == null} />);

  return (
    <Style className="panel">
      <form onSubmit={(e) => { e.preventDefault() }}>
        <label>Cliente:</label>
        <select
          name="userId"
          value={userId}
          onChange={e => setUserId(e.target.value)}>
          {usersAvailable.length > 0 && usersAvailable.map(user =>
            <option key={user.userId} value={user.userId}>{user.name} - {user.userId}</option>
          )}
        </select>
        <button
          className="btn-success "
          type="button"
          disabled={userId === "0"}
          onClick={e => {
            e.preventDefault();
            onAddUserApartment(userId);
          }}>{"Inserir"}
        </button>
      </form>
      <section className="table-title">
        <h2>Usuários do apartamento</h2>
      </section>
      <table className="table table-striped table-bordered table-hover main-table">
        <thead >
          <tr>
            <th>Nome</th>
            <th>Email</th>
            <th>Remover</th>
          </tr>
        </thead>
        <tbody>
          {userApartments?.length > 0 && userApartments.map(userAp => (
            <tr key={userAp.id}>
              <td >{userAp.name}</td>
              <td >{userAp.email}</td>
              <td className="action">
                <button onClick={() => onDeleteUserApartment(userAp.id)}>
                  <FaTrashAlt className="icon" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Style>
  )
}
